import styled from 'styled-components'
import { SliderProps } from '../../audioPlayer.types'

export const CustomProgressInputRange = styled.input<SliderProps>`
  -webkit-appearance: none;
  appearance: none;
  border-radius: 0.188rem;
  outline: none;
  cursor: pointer;
  min-width: 0;

  background: ${({ $isDarkMode, valueProgress, min, max, unfilledTrackColor = '--gray-100' }) => {
    const percent = ((valueProgress - min) * 100) / (max - min)
    return `linear-gradient(to right, var(--${$isDarkMode ? 'white' : 'black'}) ${percent}%, var(${unfilledTrackColor}) ${percent}%)`
  }};

  /* Track (Chrome, Safari, Edge) */
  &::-webkit-slider-runnable-track {
    background: var(--bg-gray-900);
    border-radius: 0.188rem;
    display: flex;
  }

  /* Thumb (Chrome, Safari, Edge) */
  &::-webkit-slider-thumb {
    display: ${({ shouldRenderThumb }) => (shouldRenderThumb ? 'block' : 'none')};
    -webkit-appearance: none;
    appearance: none;
    opacity: 0.9;
    width: 0.75rem;
    height: 0.75rem;
    border-radius: 50%;
    background: ${({ $isDarkMode }) => ($isDarkMode ? 'var(--white)' : 'var(--black)')};
    cursor: pointer;
  }

  /* Track (Firefox) */
  &::-moz-range-track {
    background: var(--bg-gray-900);
    border-radius: 0.188rem;
  }

  /* Thumb (Firefox) */
  &::-moz-range-thumb {
    opacity: ${({ shouldRenderThumb }) => (shouldRenderThumb ? '0.9' : '0')};
    width: 0.75rem;
    height: 0.75rem;
    border-radius: 50%;
    background: ${({ $isDarkMode }) => ($isDarkMode ? 'var(--white)' : 'var(--black)')};
    cursor: pointer;
  }
`

CustomProgressInputRange.displayName = 'CustomProgressInputRange'
